export const Actions = {
  LIST_RATE_CLASSES: "LIST_RATE_CLASSES",
  LIST_RATE_CLASSES_SUCCEEDED: "LIST_RATE_CLASSES_SUCCEEDED",
};
